import { ref, computed } from 'vue';

export interface UsePaginationOptions {
  defaultLimit?: number;
  useServerPagination?: boolean;
}

/**
 * Generic composable for pagination state.
 * Handles offset-based and page-based API response shapes.
 */
export function usePagination(options: UsePaginationOptions = {}) {
  const { defaultLimit = 10, useServerPagination = true } = options;

  const currentPage = ref(1);
  const limit = ref(defaultLimit);
  const totalItems = ref(0);
  const useServerPaginationRef = ref(useServerPagination);

  const totalPages = computed(() => Math.ceil(totalItems.value / limit.value) || 0);

  const setPaginationFromResponse = (response: {
    pagination?: { total: number; offset: number; limit: number };
    meta?: { total: number; page: number; limit: number };
  }) => {
    if (response.pagination) {
      totalItems.value = response.pagination.total;
      currentPage.value = Math.floor(response.pagination.offset / response.pagination.limit) + 1;
      limit.value = response.pagination.limit;
    } else if (response.meta) {
      totalItems.value = response.meta.total;
      currentPage.value = response.meta.page;
      limit.value = response.meta.limit;
    }
  };

  return {
    currentPage,
    limit,
    totalItems,
    totalPages,
    useServerPagination: useServerPaginationRef,
    setPaginationFromResponse,
  };
}
